import posthog from 'posthog-js';
import axios from 'src/utils/axiosHelper';
import authService from 'src/services/authService';
export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const UPDATE_PROFILE = '@account/update-profile';

function identifyUser(user) {
  posthog.identify(String(user.id), {
    email: user.email,
    name: `${user.firstName} ${user.lastName || ''}`.trim(),
    role: user?.roles?.[0]?.roleValue
  });
}

export function login(email, password) {
  return async dispatch => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const loger = await authService.loginWithEmailAndPassword(
        email,
        password
      );
      const user = await authService.loginInWithToken();

      identifyUser(user);
      posthog.capture('user_logged_in', { role: user?.roles?.[0]?.roleValue });

      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user
        }
      });

      return user;
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(user) {
  return dispatch => {
    identifyUser(user);
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
  };
}

export function logout() {
  return async dispatch => {
    posthog.capture('user_logged_out');
    posthog.reset();
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(update) {
  const request = axios({
    method: 'post',
    url: `/api/correction/user/{userId}`
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_PROFILE,
        payload: response.data
      })
    );
  };
}
